<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import _isArray from 'lodash/isArray'

import Checkout from 'components/Checkout'
import EventDetail from 'components/EventDetail'
import AddAdmissionGroup from 'components/AddAdmissionGroup'
import eventService from 'api/event'
import CHECKOUT_MODAL_TYPES from 'constants/checkoutModalTypes'
import store from 'src/store'
import * as mutationTypes from 'store/mutationTypes'

export default {
  name: 'checkout-modal',
  components: {
    Checkout,
    EventDetail,
    AddAdmissionGroup,
  },
  data() {
    return {
      modalVisible: false,
      showEventDetail: false,
      eventNotFound: false,
      showCheckout: false,
      showReceipt: false,
    }
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
      //
      eventId: (state) => state.config.eventId,
    }),
  },
  methods: {
    onBookingCompleted(booking) {
      this.showReceipt = true

      this.$emit('bookingCompleted', booking)
    },
    onCheckoutSessionCreated(session) {
      this.$emit('checkoutSessionCreated', session)
    },
    onAdmissionGroupCreated() {
      this.showReceipt = true
    },
    //
    onClosed() {
      this.modalVisible = false

      this.reset()

      setTimeout(() => {
        this.$emit('closed')
      }, 400)
    },
    reset() {
      this.showEventDetail = false
      this.showCheckout = false
      this.showReceipt = false
    },
    backToEventDetail() {
      this.showEventDetail = true
      this.showCheckout = false
    },
    showModal(type, options) {
      if (!type) throw new Error('type is required')
      if (!options) throw new Error('options is required')

      this.modalVisible = true

      if (type === CHECKOUT_MODAL_TYPES.EVENT) {
        if (!this.eventId) throw new Error('eventId required when checkoutModalType EVENT')

        eventService
          .getById(this.eventId)
          .then((event) => {
            this.event = event
            this.showEventDetail = true
            this.showCheckout = false

            return null
          })
          .catch(() => {
            this.eventNotFound = true

            return null
          })
      } else if (type === CHECKOUT_MODAL_TYPES.INVENTORY) {
        if (!options.inventoryId) throw new Error('inventoryId required when checkoutModalType INVENTORY')

        this.$store.dispatch('clearCheckoutCartItems') //clear cart because we should only ever have 1 inventory item for this checkout mode

        this.$store.dispatch('addCartItem', {
          inventoryId: options.inventoryId,
          quantity: options.inventoryQuantity || 1,
        })

        this.startCheckout()
      } else if (type === CHECKOUT_MODAL_TYPES.ITEMS) {
        if (!options.items || !_isArray(options.items)) throw new Error('items required when checkoutModalType ITEMS')

        options.items.forEach((item) => {
          this.$store.dispatch('addCartItem', {
            inventoryId: item.inventoryId,
            quantity: parseInt(item.quantity, 10) || 1,
          })
        })

        this.startCheckout()
      }
    },
    startCheckout() {
      this.showEventDetail = false
      this.showCheckout = true
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.START_CHECKOUT) {
        this.startCheckout()
      }
    },
  },
  mounted() {
    this.$store.dispatch('clearCheckoutCartItems')

    this.storeUnsubscribe = store.subscribe(this.onMutation)
  },
  updated() {
    this.$emit('updated')
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/CheckoutModal/index.vue